import React from "react";
import Feature from "utils/Feature";
import MyProfileRightBtnSave from "components/myprofile/features/btn.save";
import MyProfileRightBtnCancel from "components/myprofile/features/btn.cancel";
import SingleInfo from "components/myprofile/features/single.info";

export default function MyProfileRightContentInfoEdit({
  boxName,
  data,
  filterData,
  handleEvents,
}) {
  return (
    <div
      className={boxName + " row"}
      style={{
        width: "98%",
        margin: "0 auto",
        marginTop: "25px",
        paddingLeft: "20px",
        paddingRight: "20px",
      }}
    >
      <h3>Your profile</h3>
      <div
        className="col s6"
        style={{ paddingLeft: "5px", paddingRight: "5px" }}
      >
        <div className="row">
          <SingleInfo title="Work E-Mail" name="email" value={data?.email} />
          <SingleInfo title="Position" name="position" value={data?.position} />
          <SingleInfo
            title="Department"
            name="department"
            value={data?.dept_names ? data.dept_names.join(", ") : "-"}
          />
        </div>
        <div className="row">
          <SingleInfo
            title="E-leave Approver"
            name="eleave_approver"
            value={data?.eleave_approver_name}
          />
          <SingleInfo
            title="E-leave Co Approver"
            name="eleave_co_approver"
            value={data?.eleave_co_approver_name}
          />
          <SingleInfo
            title="KPI supervisor"
            name="kpi_approver"
            value={
              data?.kpi_approver_name === ""
                ? data?.eleave_approver_name
                : data?.kpi_approver_name
            }
          />
          <SingleInfo
            title="KPI Co-supervisor"
            name="kpi_co_approver"
            value={data?.kpi_co_approver_name}
          />
        </div>
        <div className="row">
          <SingleInfo
            title="Title/Salutation"
            name="title"
            value={data?.title}
            input={{
              type: "select",
              options: filterData?.titles,
              required: true,
              optionName: "name",
              optionValue: "value",
            }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="First name"
            name="fname"
            value={data?.fname}
            input={{ type: "text", required: true }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Last name"
            name="lname"
            value={data?.lname}
            input={{ type: "text", required: true }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Local name"
            name="contact_fullname_local_language"
            value={data?.contact_fullname_local_language}
            input={{ type: "text" }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Nickname"
            name="nickname"
            value={data?.nickname}
            input={{ type: "text", required: true }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Gender"
            name="gender"
            value={data?.gender}
            input={{
              type: "select",
              options: filterData?.genders,
              required: true,
              optionName: "name",
              optionValue: "value",
            }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Nationality"
            name="nationality"
            value={data?.nationality}
            input={{
              type: "select",
              options: filterData?.nationalities,
              required: true,
              optionName: "name",
              optionValue: "name",
            }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Birthday"
            name="birthday"
            value={data?.birthday}
            input={{ type: "date", required: true }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Native Language"
            name="native_language"
            value={data?.native_language}
            input={{
              type: "select",
              options: filterData?.native_languages,
              required: true,
              optionName: "name",
              optionValue: "name",
            }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Marital Status"
            name="marital_status"
            value={data?.marital_status}
            input={{
              type: "select",
              options: filterData?.maritals,
              required: false,
              optionName: "name",
              optionValue: "name",
            }}
            handleEvents={handleEvents}
          />
        </div>
      </div>
      <div
        className="col s6"
        style={{ paddingLeft: "5px", paddingRight: "5px" }}
      >
        <div className="row">
          <SingleInfo
            title="Personal E-mail"
            name="contact_email"
            value={data?.contact_email}
            input={{ type: "text" }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Home Phone"
            name="contact_home_phone"
            value={data?.contact_home_phone}
            input={{ type: "text" }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Mobile Phone"
            name="contact_mobile"
            value={data?.contact_mobile}
            input={{ type: "text" }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Address 1"
            name="contact_address"
            value={data?.contact_address}
            input={{ type: "text" }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Address 2"
            name="contact_street"
            value={data?.contact_street}
            input={{ type: "text" }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="City"
            name="contact_city"
            value={data?.contact_city}
            input={{ type: "text" }}
            handleEvents={handleEvents}
          />
          {/* <SingleInfo
          title="City"
          name="contact_city"
          value={data?.contact_city}
          input={{
            type: "select",
            options: Feature.GetDataRelateCountry(filterData.locations, data, [
              "contact_country_code",
            ]),
            required: false,
            optionName: "city",
            optionValue: "city",
            optionGroup: true,
            filters: data,
          }}
          handleEvents={handleEvents}
        /> */}
          <SingleInfo
            title="State/Province"
            name="contact_state"
            value={data?.contact_state}
            input={{ type: "text" }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Country"
            name="contact_country"
            value={data?.contact_country}
            input={{
              type: "select",
              options: Feature.GetCountryExcludeEXOGroup(
                filterData.workcountries
              ),
              required: false,
              optionName: "country_name",
              optionValue: "country_name",
              filters: data,
            }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Zip Code"
            name="contact_zipcode"
            value={data?.contact_zipcode}
            input={{ type: "text" }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Emergency Contact Name"
            name="contact_emergency_contact_name"
            value={data?.contact_emergency_contact_name}
            input={{ type: "text" }}
            handleEvents={handleEvents}
          />
          <SingleInfo
            title="Emergency Contact Number"
            name="contact_emergency_contact_number"
            value={data?.contact_emergency_contact_number}
            input={{ type: "text" }}
            handleEvents={handleEvents}
          />
        </div>
      </div>
      <div
        className="col s12"
        style={{ padding: "0px 12px", textAlign: "center" }}
      >
        <MyProfileRightBtnCancel
          data={data}
          handleEvents={handleEvents.OnCancel}
        />
        <MyProfileRightBtnSave
          data={data}
          isSaving={data?.isSaving}
          handleEvents={handleEvents.OnSave}
        />
      </div>
    </div>
  );
}
